{
  "version": 1,
  "asset_id": "e877cc1b-4b90-4cab-b26e-5360bd497e9f",
  "project_id": "6ae9d6cb-3e3f-4ef3-ac63-d04d56a97d2e",
  "url": "/__l5e/assets-v1/e877cc1b-4b90-4cab-b26e-5360bd497e9f/robotdex-logo.jpg",
  "r2_key": "a/v1/6ae9d6cb-3e3f-4ef3-ac63-d04d56a97d2e/e877cc1b-4b90-4cab-b26e-5360bd497e9f/robotdex-logo.jpg",
  "original_filename": "robotdex-logo.jpg",
  "size": 84524,
  "content_type": "image/jpeg",
  "created_at": "2026-07-10T22:06:16Z"
}
